import React from 'react';
import { object, string } from 'prop-types';
import { I18n } from '@fiverr-private/i18n-react';
import { Link, Text } from '@fiverr-private/typography';
import { Stack } from '@fiverr-private/layout_components';
import { NewBadge } from '@fiverr-private/badges';

const ResourcesListItem = ({ link: { href, copyKeys, isNew, anchorAttributes, reportBQ } }) => {
    const handleClick = (e) => {
        // Stop propagation to avoid triggering the parent’s redirect logic
        e.stopPropagation();
        reportBQ();
    };

    return (
        <Link href={href} onClick={handleClick} decoration={{ hover: 'none' }} {...anchorAttributes}>
            <Stack gap="1.5" alignItems="center">
                <Text fontWeight="semibold" color="grey_1100">
                    <I18n k={copyKeys.name} />
                </Text>
                {isNew && <NewBadge />}
            </Stack>
            <Text color="grey_1000" size="b_sm">
                <I18n k={copyKeys.caption} />
            </Text>
        </Link>
    );
};

ResourcesListItem.propTypes = {
    link: object,
    headerType: string,
};

export default ResourcesListItem;
